import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return {
		alertCircle: {
			marginLeft: 9,
			marginRight: 7
		},
	} satisfies Record<string, CSSObject>;
};
